import { clearTimeout, setTimeout } from '../shortcut'

const ErrorGroupQueue = new Map<string, Error[]>()

/**
 * 防止 react 劫持
 */
const groupLog = globalThis.console.group
const groupEndLog = globalThis.console.groupEnd
const errorLog = globalThis.console.error
const LogTimeDuration = 1000
let logGroupTimer: number

export function logErrorGroup(error: Error) {
  const name = error.name
  const group = ErrorGroupQueue.get(name)
  if (group) {
    if (group.some((e) => e.message === error.message)) return
    group.push(error)
  } else {
    ErrorGroupQueue.set(name, [error])
  }
  clearTimeout(logGroupTimer)
  logGroupTimer = setTimeout(() => {
    ErrorGroupQueue.forEach((group, name) => {
      groupLog(
        `%c ${name} `,
        'background:#d14040;color:white;padding:5px 0px;border-radius:3px'
      )
      for (const error of group) {
        errorLog(error.message)
      }
      groupEndLog()
    })
    ErrorGroupQueue.clear()
  }, LogTimeDuration)
}
